export const onLoginSuccess = ({
  response,
  url,
  legacyPasswordRouting,
  cookieLocale,
}, props) => {
  const { query: { dispatch } } = props;
  const { dateOfLastPasswordChange } = response;
  if (window.AmexSession) {
    window.AmexSession.options({
      locale: cookieLocale,
    });
    window.AmexSession.start();
  }
  if (window && (window !== window.top)) {
    window.top.postMessage({
      messageId: 'LOGIN',
      status: 'Success',
      target: url,
    }, '*');
  } else if (dispatch === 'true') {
    window.dispatchEvent(new CustomEvent('oneIdentityLogin', { detail: { response, destination: url } }));
  } else {
    legacyPasswordRouting(dateOfLastPasswordChange, url, response);
  }
};
